import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-sidenav-join-block',
  styleUrls: ['./sidenav-join-block.component.scss'],
  templateUrl: './sidenav-join-block.component.html',
})
export class SidenavJoinBlockComponent {
  @Input() merchantCount: number | null | undefined;
}
